<form *ngIf="form" (ngSubmit)="onSubmit()" [formGroup]="form">
    <wuc-form-field>
        <wuc-form-field-label>Geslacht</wuc-form-field-label>
        <wuc-input-radio name="genderCode" [formControl]="genderCode" [value]="genderCodeEnum.Male"
                         id="genderCodeMale">Man</wuc-input-radio>
        <wuc-input-radio name="genderCode" [formControl]="genderCode" [value]="genderCodeEnum.Female"
                         id="genderCodeFemale">Vrouw</wuc-input-radio>
    </wuc-form-field>
    <wuc-form-field>
        <wuc-form-field-label for="initials">Voorletters</wuc-form-field-label>
        <wuc-input-initials [formControl]="initials" name="initials"></wuc-input-initials>
        <wuc-input-alert *ngIf="initials.touched && initials.invalid" alertType="error" icon="cross-closed"
                         [messages]="['Vul uw voorletters in.']"></wuc-input-alert>
    </wuc-form-field>
    <wuc-form-field>
        <wuc-form-field-label for="middleNameInitials">Tussenvoegsel(s)</wuc-form-field-label>
        <wuc-input-text [formControl]="middleNameInitials" name="middleNameInitials" placeholder="optioneel"></wuc-input-text>
    </wuc-form-field>
    <wuc-form-field>
        <wuc-form-field-label for="surname">Achternaam</wuc-form-field-label>
        <wuc-input-text [formControl]="surname" name="surname"></wuc-input-text>
        <wuc-input-alert *ngIf="surname.touched && surname.invalid" alertType="error" icon="cross-closed"
                         [messages]="['Vul uw achternaam in.']"></wuc-input-alert>
    </wuc-form-field>
    <wuc-form-field>
        <wuc-form-field-label for="birthdate">Geboortedatum</wuc-form-field-label>
        <wuc-input-date [formControl]="birthdate" name="birthdate" id="birthdate" placeholder="dd-mm-jjjj"></wuc-input-date>
        <wuc-input-alert *ngIf="birthdate.touched && birthdate.invalid" alertType="error" icon="cross-closed"
            [messages]="['Sorry, maar de bestuurder moet minimaal ' + getMinimumAge() + ' jaar zijn.']"></wuc-input-alert>
    </wuc-form-field>
    <wuc-form-field>
        <wuc-form-field-label for="start_date">Ingangsdatum</wuc-form-field-label>
        <wuc-input-date-picker [formControl]="startDate" name="start_date" [minDate]="minimumStartDate"></wuc-input-date-picker>
        <wuc-input-alert *ngIf="startDate.touched && startDate.hasError('required')"
                         alertType="error" icon="cross-closed" [messages]="['Vul uw ingangsdatum in.']">
        </wuc-input-alert>
        <wuc-form-field-subtext *ngIf="errors?.length > 0">
            <wuc-balloon backgroundStyle="secondary" arrowPosition="topLeft" padding="medium" [hasCloseIcon]="false" [isFullWidth]="true">
                <wuc-list icon="cross">
                    <ng-container *ngFor="let error of errors">
                        <wuc-list-item>{{ error.message }}</wuc-list-item>
                    </ng-container>
                </wuc-list>
            </wuc-balloon>
        </wuc-form-field-subtext>
    </wuc-form-field>
    <wuc-form-field>
        <wuc-form-field-label></wuc-form-field-label>
        <wuc-button [isSubmitButton]="true" [isFullWidth]="true" [disabled]="isDisabled">Opslaan</wuc-button>
    </wuc-form-field>
</form>
